var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var StyledEmailPreview = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 1rem;\n"], ["\n  margin-top: 1rem;\n"])));
function createMarkup(props) {
    return { __html: props.content.body };
}
var EmailPreview = function (props) {
    return _jsx(StyledEmailPreview, { children: _jsx("span", { dangerouslySetInnerHTML: createMarkup(props) }) });
};
export default EmailPreview;
var templateObject_1;
